/**
 * Talker funnel events (Sam, Oct 21 2026). GA4 event `tf_<name>` (when gtag is loaded)
 * + POST /api/tf server log line. Works for guests via an anonymous id.
 */
const AKEY = 'sl_tf_anon';
let uid = null;
const seen = {};

export const TALKER_FUNNEL_EVENTS = [
  'ad_landing', 'profile_view', 'talk_now_tap', 'booking_choice', 'signup_started', 'signup_done',
  'email_code', 'adult_confirm', 'card_id_done', 'session_started', 'session_completed',
  'rebook_tap', 'match_me_tap',
];

export const setTalkerFunnelUser = id => {
  uid = typeof id === 'string' ? id : id?.uuid || null;
};

const anonId = () => {
  try {
    let a = window.localStorage.getItem(AKEY);
    if (!a) {
      a = Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      window.localStorage.setItem(AKEY, a);
    }
    return a;
  } catch (e) {
    return null;
  }
};

const utmFromUrl = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const utm = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(k => {
      const v = q.get(`utm_${k}`);
      if (v) utm[k] = v.slice(0, 60);
    });
    if (!utm.source && q.get('ttclid')) utm.source = 'tiktok';
    if (!utm.source && q.get('fbclid')) utm.source = 'facebook';
    if (!utm.source && q.get('gclid')) utm.source = 'google-ads';
    return Object.keys(utm).length ? utm : null;
  } catch (e) {
    return null;
  }
};

/**
 * @param {string} event one of TALKER_FUNNEL_EVENTS
 * @param {{ listingId?: string, detail?: string, once?: boolean, utm?: Object }} [opts]
 */
export const trackTalkerFunnel = (event, opts = {}) => {
  if (typeof window === 'undefined' || !TALKER_FUNNEL_EVENTS.includes(event)) return;
  const { listingId, detail, once = false, utm } = opts;
  const l = typeof listingId === 'string' ? listingId : listingId?.uuid || null;
  const key = `${event}|${l || ''}|${detail || ''}`;
  if (once) {
    if (seen[key] && Date.now() - seen[key] < 30000) return;
    seen[key] = Date.now();
  }
  const body = { e: event, a: anonId(), uid, l, d: detail || null, utm: utm || null };
  try {
    window.fetch('/api/tf', {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  } catch (e) {
    // ignore
  }
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', `tf_${event}`, { listing_id: l || undefined, detail: detail || undefined, ...(utm ? { utm_source: utm.source, utm_campaign: utm.campaign } : {}) });
    }
  } catch (e) {
    // ignore
  }
};

/** Once per page load: an ad landing when the URL carries utm / click ids. */
export const trackAdLanding = () => {
  const utm = utmFromUrl();
  if (utm) trackTalkerFunnel('ad_landing', { utm, detail: window.location.pathname.slice(0, 24), once: true });
};
